var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo\">\r\n    <h2>\r\n        <strong>Promoción finalizada</strong> <br />\r\n        No te quedes sin acceder a periodismo de calidad y los beneficios de Club LA NACION\r\n    </h2>\r\n\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/header/promo_vencida.hbs
// module id = 495
// module chunks = 0 1